import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const key = user ? `kb_cart_${user.id}` : null;
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!key) {
      setItems([]);
      return;
    }
    try {
      setItems(JSON.parse(localStorage.getItem(key)) || []);
    } catch {
      setItems([]);
    }
  }, [key]);

  const update = (fn) =>
    setItems((prev) => {
      const next = fn(prev);
      if (key) localStorage.setItem(key, JSON.stringify(next));
      return next;
    });

  const addLine = (product, opts = { quantity: 1 }) =>
    update((prev) => {
      const found = prev.find((l) => l.product.id === product.id);
      if (found) return prev.map((l) => (l === found ? { ...l, ...opts, quantity: l.quantity + opts.quantity } : l));
      return [...prev, { product, reconstitute: false, bac_option: "recommended", custom_bac_ml: "", ...opts }];
    });
  const add = (product) => addLine(product);

  const change = (productId, patch) =>
    update((prev) => prev.map((l) => (l.product.id === productId ? { ...l, ...patch } : l)));
  const remove = (productId) => update((prev) => prev.filter((l) => l.product.id !== productId));
  const clear = () => update(() => []);
  const sync = (products) =>
    update((prev) =>
      prev
        .map((l) => ({ ...l, product: products.find((p) => p.id === l.product.id) }))
        .filter((l) => l.product && l.product.stock_status !== "out_of_stock")
    );
  const count = items.reduce((s, l) => s + l.quantity, 0);

  return <CartCtx.Provider value={{ items, add, addLine, change, remove, clear, sync, count }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
